// Permanent redirect — /scripts folded into the /analysis-setup hub (scripts
// step). ScriptsWorkbench now renders there (see -scripts.lazy.tsx removal);
// no search params to round-trip.
import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/scripts')({
  beforeLoad: () => {
    throw redirect({
      to: '/analysis-setup/scripts',
      replace: true,
    });
  },
});
